import { memo, useEffect, useState } from "react";
import {
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  List,
  ListItem,
  ListSubheader,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimeField } from "@mui/x-date-pickers";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  addUser,
  editDaoTrang,
  editUser,
  selectDaoTrangById,
  selectMembers,
} from "../../features/daoTrang/daoTrangSlice";
import {
  createUser,
  genAccount,
  newDefaultUser,
  saveUser,
  updateUser,
  USER_FIELDS,
} from "../../services/user/userApi";
import { Content } from "../Content/Content";
import dayjs from "dayjs";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import { AccountMenu } from "./AccountMenu";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { updateDaoTrang } from "../../services/daoTrang/daoTrangApi";
import { blue } from "@mui/material/colors";
import { useCallback } from "react";

const hdrs = {
  // email: { type: String, alias: "Account" },
  birth: { type: "Date", g: 1 },
  gender: { type: "String", g: 1 },
  phone: { type: "String", g: 1 },
  zalo: { type: "String", g: 1 },
  facebook: { type: "String", g: 1 },
  gmail: { type: "String", g: 1 },
  address: { type: "String", g: 1 }, //dia chi NB
  address2: { type: "String", g: 1 }, //dia chi VN
  ngayVaoDaoTrang: { type: "Date", g: 2 },
  ngayLenGieoDuyen: { type: "Date", g: 2 },
  ngayLenTuyHy: { type: "Date", g: 2 },
  ngayLenDuThinh: { type: "Date", g: 2 },
  ngayLenChinhThuc: { type: "Date", g: 2 },
  phapDanh: { type: "String", g: 1 },
  thanhPhan: { type: "String", g: 2 }, // A, B, C , D
  ngheNghiep: { type: "String", g: 3 },
  kyNang: { type: "String", g: 3 },
  tenFb: { type: "String", g: 3 },
  cachDTT: { type: "String", g: 3 },
  bach7: { type: "String", g: 3 }, // 0:chưa|1:đang|2:bạch xong
  bach49: { type: "String", g: 3 },
  bach108:{ type: "String", g: 3 },
  nguoiHuongDan:{ type: "String", g: 3 },
};
const groups = {
  "Cơ bản": [
    { key: "birth", type: "Date" },
    { key: "phapDanh", type: "String", g: 1 },
    { key: "phone", type: "String" },
    { key: "facebook", type: "String" },
    { key: "thanhPhan", type: "String", g: 2 }, // A, B, C , D
    { key: "address", type: "String" }, //dia chi NB
  ],
  "Bổ sung": [
    { key: "gmail", type: "String" },
    { key: "zalo", type: "String" },
    { key: "address2", type: "String" }, //dia chi VN
  ],
  "Thông tin khác": [
    { key: "ngayVaoDaoTrang", type: "Date", g: 2 },
    { key: "ngayLenGieoDuyen", type: "Date", g: 2 },
    { key: "ngayLenTuyHy", type: "Date", g: 2 },
    { key: "ngayLenDuThinh", type: "Date", g: 2 },
    { key: "ngayLenChinhThuc", type: "Date", g: 2 },
    { key: "ngheNghiep", type: "String", g: 3 },
    { key: "kyNang", type: "String", g: 3 },
    { key: "tenFb", type: "String", g: 3 },
    { key: "cachDTT", type: "String", g: 3 }, 
    { key:"bach7", type: "String"}, // 0:chưa|1:đang|2:bạch xong
    { key:"bach49", type: "String"}, // 0:chưa|1:đang|2:bạch xong
    { key:"bach108", type: "String"}, // 0:chưa|1:đang|2:bạch xong
    { key:"nguoiHuongDan", type: "String"}, // 0:chưa|1:đang|2:bạch xong
  ],
};
Object.entries(groups).forEach(([groupName, cols])=>{
  cols.forEach(col=>{
    var field = USER_FIELDS.find(f=>f.key === col.key);
    if (field) {col.alias = field.alias;}
  });
});

const UserEdit = ({ navigate, params }) => {
  const { id, daoTrangId } = params; // userId
  console.log("daoTrangs/", daoTrangId, "/users/", id);

  const dispatch = useAppDispatch();
  const members = useAppSelector(selectMembers);
  const daoTrang = useAppSelector((s) => selectDaoTrangById(s, daoTrangId));

  const [candidates, setCandidates] = useState([newDefaultUser()]);
  const [selected, setSelected] = useState(0);
  const [popupState, showPopup] = useState(false);
  const user = candidates[selected];
  const setUser = useCallback((newUser) => {
    var newArray = candidates.toSpliced(selected, 1, newUser);
    setCandidates(newArray);
  },[candidates, selected]);

  useEffect(() => {
    try {
      if (!id && daoTrangId) {
        // add new user
        return;
      }

      var base = members.find((u) => u.id === id);
      if (!base) {
        return;
      }

      // var newObj = {};
      // Object.keys(hdrs).forEach((key) => {
      //   var val = toRaw(key, base);
      //   newObj[key] = val;
      // });
      console.log(base);
      setCandidates([{ ...base }]);
      setSelected(0);
    } catch (ex) {
      console.log(ex.message);
    }
  }, [daoTrangId, id, members, navigate]);

  const handleSubmit = async (event) => {
    var userId = user.id;
    if (!userId) {
      // new user
      const newObj = { ...user, daoTrang: daoTrangId };
      // Object.keys(hdrs).forEach((key) => {
      //   var val = fromRaw(user, key);
      //   if (val) {
      //     newObj[key] = val;
      //   }
      // });

      console.log("create users:", newObj);
      const { result: newUser, error } = await createUser(newObj);
      if (newUser) {
        dispatch(addUser({ user: newUser }));
        await addUserToDaotrang();
      } else {
        console.log(error);
      }
    } else if (!id) {
      console.log("add >> select user>> save:", user);
      var { error } = await saveUser(user);
      if (!error) {
        dispatch(addUser({ user: user }));
        await addUserToDaotrang();
      } else {
        console.log(error);
      }
    } else {
      console.log("edit user>> save:", user);
      await saveChanged(members, userId, user, dispatch);
    }
    navigate(-1);

    async function addUserToDaotrang() {
      if (!daoTrang.members.find((u) => u.email === user.email)) {
        var changes = { members: daoTrang.members.concat(user.email) };
        const { error: updateDtError } = await updateDaoTrang(
          daoTrangId,
          changes
        );
        if (!updateDtError) {
          dispatch(editDaoTrang({ id: daoTrangId, changes }));
        } else {
          console.log(updateDtError);
        }
      }
    }
  };
  const handleCancel = (event) => {
    event.preventDefault();

    // console.log(event);
    navigate(-1);
  };

  const handleInputChange = (raw, key, type) => {
    console.log("handleInputChange", raw);
    var edited = { ...user, [key]: raw };
    console.log(edited);
    setUser(edited);
  };
  const handleDateChange = (day, key, type) => {
    console.log(day);
    var edited = { ...user, [key]: day ? day.format("YYYY-MM-DD") : "" };
    console.log(edited);
    setUser(edited);
  };
  const handleTimeChange = (day, key, type) => {
    console.log(day);
    var edited = { ...user, [key]: day };
    console.log(edited);
    setUser(edited);
  };

  async function genAcc(name) {
    // fetch data
    const { result } = await genAccount(name);
    if (result) {
      console.log(result);
      // setUser({...user, email:result.account})
      result.users.unshift({ ...user, name, email: result.account });
      setCandidates(result.users);
      if (result.users.length > 1) {
        // show popup
        showPopup(true);
      }
    }
  }

  function AccountSelect({ age }) {
    const options = candidates.map((u, i) => ({
      onClick: () => {
        setSelected(i);
      },
      icon:
        i === selected ? (
          <RadioButtonCheckedIcon fontSize="small" />
        ) : (
          <RadioButtonUncheckedIcon fontSize="small" />
        ),
      label: u.email,
    }));
    return <AccountMenu options={options}></AccountMenu>;
  }

  function CustomizedInputBase({
    value: inValue = "",
    email = "",
    onChange = (_name) => {},
    onSearch = (_name) => {},
  }) {
    const [value, setValue] = useState("");
    useEffect(() => {
      setValue(inValue);
    }, [inValue]);
    return (
      <Paper
        component="form"
        sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: 400 }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Họ tên"
          inputProps={{ "aria-label": "Họ tên" }}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
        />
        {email && <Chip label={email}></Chip>}
        <IconButton
          type="button"
          sx={{ p: "10px" }}
          aria-label="search"
          onClick={() => onSearch(value)}
        >
          <SearchIcon />
        </IconButton>
        <AccountSelect></AccountSelect>
      </Paper>
    );
  }
  console("groups: ", groups);
  return (
    <Content
      title={
        <Stack
          spacing={2}
          direction={"row"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Typography variant="h5">{id ? "Edit User" : "New User"}</Typography>
          <CustomizedInputBase
            value={user.name}
            email={user.email}
            // onChange={(v) => handleInputChange(v, "name", "raw")}
            onSearch={(v) => genAcc(v)}
          ></CustomizedInputBase>
        </Stack>
      }
      footer={
        <Stack direction={"row"} spacing={2}>
          <Button variant="contained" onClick={handleSubmit}>
            Save
          </Button>
          <Button variant="contained" onClick={handleCancel}>
            Cancel
          </Button>
        </Stack>
      }
    >
      <Dialog open={popupState} onClose={() => showPopup(false)}>
        <DialogTitle>{"Select account"}</DialogTitle>
        <DialogContent>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={selected}
              onChange={(_e, v) => {
                setSelected(parseInt(v));
                showPopup(false);
              }}
            >
              <Table>
                <TableBody>
                  {candidates.map((u, i) => (
                    <TableRow key={i}>
                      <TableCell>
                        <FormControlLabel
                          value={i}
                          control={<Radio />}
                          label={u.email}
                        ></FormControlLabel>
                      </TableCell>
                      <TableCell>{u.birth || "-"}</TableCell>
                      <TableCell>{u.thanhPhan || "-"}</TableCell>
                      <TableCell>{u.phapDanh || "-"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </RadioGroup>
          </FormControl>
        </DialogContent>
      </Dialog>
      <div style={{ padding: "1rem" }}>
        {user && (
          <List
            sx={{
              width: "100%",
              // maxWidth: 360,
              bgcolor: "background.paper",
              position: "relative",
              overflow: "auto",
              maxHeight: 600,
              "& ul": { padding: 0 },
            }}
            subheader={<li />}
          >
            {Object.entries(groups).map(([groupName, cols]) => (
              <li key={groupName}>
                <ul>
                  <ListSubheader sx={{background:blue[100], zIndex:100}}>{`${groupName}`}</ListSubheader>
                  {cols.map(({ key, type, alias }, i) => {
                    var raw = toRaw(key, user);
                    // var hdr = hdrs[key];
                    var label = alias || key;
                    return (
                      <ul key={key}>
                        <ListItem>
                          {type === "Date" ? (
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                label={label}
                                format="YYYY-MM-DD"
                                value={
                                  dayjs(user[key]).isValid()
                                    ? dayjs(user[key])
                                    : null
                                }
                                onChange={(newValue) =>
                                  handleDateChange(newValue, key, "Date")
                                }
                              />
                            </LocalizationProvider>
                          ) : type === "Time" ? (
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <TimeField
                                label={label}
                                format="HH:mm"
                                value={raw}
                                onChange={(newValue) =>
                                  handleTimeChange(newValue, key, "Time")
                                }
                              />
                            </LocalizationProvider>
                          ) : (
                            <TextField
                              label={label}
                              type="text"
                              value={user[key] || ""}
                              onChange={(e) =>
                                handleInputChange(e.target.value, key, "raw")
                              }
                              sx={{width:"100%"}}
                            ></TextField>
                          )}
                        </ListItem>
                      </ul>
                    );
                  })}
                </ul>
              </li>
            ))}
          </List>
        )}
      </div>
    </Content>
  );
};

export default memo(UserEdit);
async function saveChanged(members, id, user, dispatch) {
  var changes = {};
  var base = members.find((u) => u.id === id);
  console.log({ base, user });
  if (base.name !== user.name) {
    changes.name = user.name;
  }
  var fields = Object.keys(hdrs);
  fields.push("name", "email");
  fields.forEach((key) => {
    // var val = fromRaw(user, key);
    var val = user[key];
    if (val !== base[key]) {
      changes[key] = val;
    }
  });
  console.log(changes);
  if (Object.keys(changes).length > 0) {
    const { result, error } = await updateUser(id, changes);
    if (result) {
      dispatch(editUser({ id, changes }));
    } else {
      console.log(error);
    }
  }
}

function toRaw(key, user) {
  try {
    const isArray = Array.isArray(hdrs[key]);
    var raw = isArray
      ? user[key]
        ? user[key].join(", ")
        : ""
      : hdrs[key].type === "Date"
      ? user[key]
        ? dayjs(user[key])
        : ""
      : user[key]
      ? user[key]
      : "";
    return raw;
  } catch (ex) {
    console.log(ex.message);
  }
}
function fromRaw(user, key) {
  try {
    const isArray = Array.isArray(hdrs[key]);
    var val = isArray
      ? user[key]
        ? user[key].split(/[, ]/)
        : []
      : hdrs[key].type.name === "Date"
      ? user[key].format("YYYY-MM-DD")
      : user[key];
    return val;
  } catch (ex) {
    console.log(ex.message, key, user);
  }
}
